import { render, staticRenderFns } from "./Show-ajuste-estoque.vue?vue&type=template&id=8ab7f67c&scoped=true&"
import script from "./Show-ajuste-estoque.vue?vue&type=script&lang=js&"
export * from "./Show-ajuste-estoque.vue?vue&type=script&lang=js&"
import style0 from "./Show-ajuste-estoque.vue?vue&type=style&index=0&id=8ab7f67c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ab7f67c",
  null
  
)

export default component.exports